var registerPrimitive = require('../primitives').registerPrimitive;

registerPrimitive('a-link', {
  defaultComponents: {},

  mappings: {
    href: 'link.href',
    image: 'link.image',
    title: 'link.title'
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/aframe/src/extras/primitives/primitives/a-link.js
// module id = 2069
// module chunks = 0